import * as _ from 'lodash'
import { updateAreaActiveDependsOnValue } from 'src/app/core/helpers/fields-utils'
import { isPlatformBrowser } from '@angular/common'

export function inputAreaSetActive(tgEl: any): void {
  if (tgEl.classList.contains('input-area__inactive')) {
    tgEl.classList.remove('input-area__inactive')
    tgEl.classList.add('input-area__active')
    tgEl.querySelector('input').focus()
  }
}

/**
 * manipulate with account's inputs
 * @param event - event with target
 */
export function clickoutCloseInputAccount(event: any): void {
  if (!event?.target?.parentElement?.classList) {
    return
  }
  //  const prohibitedClasses = ['modal', 'account-modal__wrapper']
  //  if (scanParentsForClasses(event?.target, prohibitedClasses)) { return }
  // console.log('close input clickout account')
  let items = event.currentTarget.querySelectorAll('[class*=\'input-container\']')

  const clickedArea = (event.target as HTMLElement).closest('.input-area__active, .input-area__inactive')
  if (clickedArea) {
    items = _.filter(items, (x) => x !== clickedArea)
  }
  changeInputVisibleStateAll(items)
}

/**
 * for over all arrayData
 * if input is not empty set active, else inactive
 * @param arrayData - elements with input-area
 */
export function changeInputVisibleStateAll(arrayData: NodeList): void {
  arrayData.forEach((el: any) => {
    const inputField = el.querySelector('input')
    if (inputField) {
      updateAreaActiveDependsOnValue(el)
    }
  })
}

/**
 * make pasword input visible/invisible
 */
export function togglePasswordFor(document, selector: string): void {
/*   if (!isPlatformBrowser(this.platformId)) {
    return;
  } */
  const passInput = document.querySelector(selector) as HTMLInputElement
  if (passInput?.type) {
    // tslint:disable-next-line: tsr-detect-possible-timing-attacks
    passInput.type = passInput.type === 'password' ? 'text' : 'password'
  }
}

/**
 * toggle 'show' class on target sibling or parent sibling
 * @param e - event
 */
export function toggleNeighbourMessageOn(e: Event): void {
  const showToken = 'show'
  const targetClass = 'input__message'
  const target = e.currentTarget as HTMLElement
  // console.log(target)
  if (target.nextElementSibling?.classList.contains(targetClass)) {
    target.nextElementSibling.classList.toggle(showToken)
  }
  else if (target.parentElement.nextElementSibling?.classList.contains(targetClass)) {
    target.parentElement.nextElementSibling.classList.toggle(showToken)
  }
}
